import { useSupabaseCallback } from "../../../server/supabase/hooks";
import { useMultiformat } from "../../multiformat/hooks/use-multi-format";
import { SupabaseDigitalAssetService, toAssets, type Asset } from "../server/digital-asset-service";

export const useGetImageAssets = (): (() => Promise<Asset[] | undefined>) => {
  const multiformat = useMultiformat();

  return useSupabaseCallback(
    async ({ supabase, account_id }): Promise<Asset[]> => {
      const { data, error } = await new SupabaseDigitalAssetService(supabase).getAll(account_id, {
        order: [{ column: "updated_at", dir: "desc" }],
        filter: [{ key: "deleted_at", operator: "is", value: null }],
      });
      if (error) throw new Error(error.message);
      const assets = toAssets(data);

      const invalidContentTypes =
        multiformat.data?.content_types
          .filter((c) => c.multipage || c.prototype)
          .map((c) => c.name) ?? [];

      const validAssets = assets.filter(
        (x) =>
          x.public_url &&
          ((x.content_type === "Uploaded File" && x.mime_type?.startsWith("image/")) ||
            ![...invalidContentTypes, "Uploaded File"].includes(x.content_type)),
      );

      return validAssets;
    },
    [multiformat.data],
  );
};
